import React from "react";
import { getIcon } from "../../constants/constants";

function ConversationSidebar({ groups, selectedKey, onSelect }) {
  return (
    <div
      className="d-flex flex-column border-end flex-shrink-0"
      style={{ width: "clamp(220px, 22%, 300px)" }}
    >
      <div className="px-3 py-3 border-bottom flex-shrink-0">
        <h5 className="fw-bold mb-0">Conversations</h5>
        <small className="text-body-secondary">{groups.length} channels</small>
      </div>
      <div className="overflow-y-auto flex-grow-1 py-2">
        {groups.length === 0 ? (
          <div className="text-center py-5 text-body-secondary px-3">
            <div className="fs-3 mb-2">💬</div>
            <small>No conversations found</small>
          </div>
        ) : (
          groups.map((group) => {
            const isActive = selectedKey === group.key;
            const iconUrl = getIcon(group.platform);

            return (
              <div
                key={group.key}
                onClick={() => onSelect(group.key)}
                className={`d-flex align-items-center gap-2 px-3 py-2 mx-2 rounded-3 mb-1 ${
                  isActive ? "bg-primary text-white shadow-sm" : "bg-transparent"
                }`}
                style={{ cursor: "pointer", transition: "all .2s ease" }}
              >
                <div
                  className={`d-flex align-items-center justify-content-center rounded-circle flex-shrink-0 ${
                    isActive ? "bg-light bg-opacity-25" : "bg-body-secondary"
                  }`}
                  style={{ width: 34, height: 34 }}
                >
                  {iconUrl ? (
                    <img src={iconUrl} alt={group.platform} width={18} height={18} />
                  ) : (
                    <i className={`bi ${group.isChannel ? "bi-hash" : "bi-grid"}`} />
                  )}
                </div>

                <div className="overflow-hidden flex-grow-1">
                  <div className="fw-semibold text-truncate" style={{ fontSize: 13 }}>
                    {group.isChannel ? `#${group.label}` : group.label}
                  </div>
                  <div
                    className={`text-truncate ${isActive ? "text-white-50" : "text-body-secondary"}`}
                    style={{ fontSize: 11 }}
                  >
                    {group.platform} · {group.messages.length} messages
                  </div>
                </div>

                <span
                  className={`badge rounded-pill flex-shrink-0 ${
                    isActive ? "bg-light text-dark" : "bg-secondary-subtle text-secondary-emphasis"
                  }`}
                >
                  {group.messages.length}
                </span>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}

export default ConversationSidebar;